import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppDispatch } from "@store/store-helper";
import { addMembersToTeam } from "@store/teams/teams-slice-thunk";
import { getAddMembersToTeamErrors } from "@utils/team-utils";
/**
 * Throws when the backend could not add some of the members. The endpoint reports those members
 * in `errorData` of a successful response instead of failing the request, so without this check
 * they would look as if they had been added.
 */
function throwIfMembersNotAdded(response) {
  const messages = getAddMembersToTeamErrors(response);
  if (messages.length) {
    throw new Error(messages.join("\n"));
  }
}

/** Returns a function that adds a single workspace member to a team */
export function useAddMemberToTeam() {
  const $ = _c(3);
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  let t0;
  if ($[0] !== companyId || $[1] !== dispatch) {
    t0 = async t1 => {
      const {
        teamId,
        member
      } = t1;
      const response = await dispatch(addMembersToTeam({
        companyId,
        teamId,
        members: [member.identity]
      })).unwrap();
      throwIfMembersNotAdded(response);
    };
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}